
import { defineComponent, PropType, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
export default defineComponent({
  name: "PasswordInput",
  components: { Field, ErrorMessage },
  props: {
    input: { type: Object as PropType<any>, required: true },
    id: { type: String, required: true },
    modelValue: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const model = computed({
      get: () => props.modelValue,
      set: (v) => emit("update:modelValue", v),
    });
    const onChange = () => props.input?.change && props.input.change({});
    return { model, onChange };
  },
});
